<template>
  <div class="col_xl_4 col_l_4 col_m_4 s_hide">
    <div class="avatar_wrap" v-if="user">
      <img :src="user.picture" alt="" v-if="user.picture" />
      <span v-else>{{ user.displayName[0] }}{{ user.displayName[1] }}</span>
    </div>

    <p class="user_name" v-if="$store.state.user">
      {{ $store.state.user.name }}
    </p>

    <div class="user_links">
      <router-link to="/user_rooms" class="hover_op">Rooms</router-link>
      <router-link to="/user_subscriptions" class="hover_op"
        >Subscription</router-link
      >
      <router-link to="/user_profile" class="hover_op">Profile</router-link>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    uploadProfilePhoto(event) {
      try {
        const file = event.target.files;

        const formData = new FormData();

        formData.append("picture", file);

        Axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/api/users/me`,
          formData
        );
        window.location.reload();
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    async updateProfilePhoto(event) {
      try {
        await Axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/api/users/me`,
          {
            headers: {
              headers: {
                picture: event.target.files,
              },
            },
          }
        );
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss">
.user_name {
  color: #000;
  font-family: "Playfair Display", serif;
  font-size: 36px;
  font-weight: 400;
  line-height: 48px;
  margin-bottom: 64px;
}

.avatar_wrap {
  width: 128px;
  height: 128px;
  border-radius: 16px;
  background-color: #000;
  margin-bottom: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  color: #fff;
  font-family: "Playfair Display", serif;
  font-size: 36px;
  font-weight: 400;
  line-height: 48px;
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
  }

  & > * {
    z-index: 1;
  }

  &::before {
    z-index: 0;
    content: "";
    position: absolute;
    top: 50%;
    bottom: 0;
    right: 0;
    left: 0;
    background-image: linear-gradient(
      180deg,
      rgba(249, 244, 239, 0) 0%,
      #f9f4ef 100%
    );
    opacity: 0.64;
  }
}

.user_links {
  margin-bottom: 64px;

  a {
    display: block;
    opacity: 0.32;
    transition: opacity 180ms;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    & + a {
      margin-top: 16px;
    }

    &.router-link-active {
      font-family: "Nunito Sans", sans-serif;
      font-weight: 700;
    }

    &.router-link-active,
    &:hover {
      opacity: 1;
      transition: opacity 180ms;
    }
  }
}
</style>
